export type PageTypes = 'profile' | 'user';

export enum NotificationType {
  inspection_available = 'inspection_available',
  checklist_reminder = 'checklist_reminder',
  inspection_overdue_for_supervisors = 'inspection_overdue_for_supervisors',
  issue_available = 'issue_available',
  issue_reminder = 'issue_reminder',
  approval_pending = 'approval_pending',
  issue_approval_pending = 'issue_approval_pending',
  approval_status_change = 'approval_status_change',
  issue_approval_status_change = 'issue_approval_status_change'
}

export enum ScaleType {
  minute = 'minute',
  hour = 'hour',
  day = 'day',
  week = 'week'
}

export enum ScaleMinutes {
  week = 60 * 24 * 7,
  day = 60 * 24,
  hour = 60,
  minute = 1
}

export const TimeWindowLabelKeys: Record<string, string> = {
  60: 'reminder-notification.1h-2h',
  120: 'reminder-notification.2h-2days',
  2880: 'reminder-notification.1days-2weeks',
  20160: 'reminder-notification.more-than-2weeks',
};

// if we move the max_minutes and max_time properties to response object we can can remove timeWindowValues
export const timeWindowValues = [
  {
    from: 60,
    to: 120,
    max_minutes: 60,
    max_time: '1_hour',
  },
  {
    from: 120,
    to: 2880,
    max_minutes: 120,
    max_time: '2_hours',
  },
  {
    from: 2880,
    to: 20160,
    max_minutes: 2880,
    max_time: '48_hours',
  },
  {
    from: 20160,
    to: null,
    max_minutes: 20160,
    max_time: '14_days',
  },
];
